const toFiniteId = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

const normalizeIdList = (values = []) => (
  [...new Set(
    (Array.isArray(values) ? values : [])
      .map(toFiniteId)
      .filter(Boolean)
  )]
);

export const isTerminalLiveMatchStatus = (match = {}) => {
  const status = String(match?.status || match?.fixture_status || '').trim().toUpperCase();
  const terminalAuthority = String(
    match?.terminal_authority
    || match?.terminalAuthority
    || match?.meta?.terminal_authority
    || ''
  ).trim().toLowerCase();
  const hasTerminalRemoval = (
    (Array.isArray(match?.terminalRemovals) && match.terminalRemovals.length > 0)
    || (Array.isArray(match?.terminal_removals) && match.terminal_removals.length > 0)
  );

  return (
    ['CANCELLED', 'CLOSED', 'SETTLED', 'ENDED', 'FINISHED', 'FT'].includes(status)
    || terminalAuthority === 'removescope_terminal_fixture'
    || terminalAuthority === 'recovery_terminal_removals'
    || hasTerminalRemoval
  );
};

export const resolveStickyLiveDetailTargetId = ({
  selectedMatchId = null,
} = {}) => (
  toFiniteId(selectedMatchId)
  || null
);

export const buildStickyLiveCardMatchIds = ({
  liveMatches = [],
  detailTargetId = null,
  cartMatchIds = [],
  prefetchLimit = 2,
} = {}) => {
  const visibleIds = (Array.isArray(liveMatches) ? liveMatches : [])
    .slice(0, Math.max(0, Number(prefetchLimit) || 0))
    .map((match) => toFiniteId(match?.id))
    .filter(Boolean);

  return normalizeIdList([
    ...visibleIds,
    toFiniteId(detailTargetId),
    ...normalizeIdList(cartMatchIds),
  ]).sort((a, b) => a - b);
};

export const shouldClearLiveCardMarketCache = ({
  activeMatchIds = [],
  detailTargetId = null,
  cartMatchIds = [],
} = {}) => (
  normalizeIdList(activeMatchIds).length === 0
  && !toFiniteId(detailTargetId)
  && normalizeIdList(cartMatchIds).length === 0
);

export const resolveStickyLiveSelectedShell = ({
  detailTargetId = null,
  matchDetail = null,
  matches = [],
  liveMatches = [],
} = {}) => {
  const detailId = toFiniteId(detailTargetId);

  if (detailId) {
    const row = [
      ...(Array.isArray(matches) ? matches : []),
      ...(Array.isArray(liveMatches) ? liveMatches : []),
    ]
      .find((match) => toFiniteId(match?.id) === detailId);
    if (row) return row;
  }

  if (detailId && toFiniteId(matchDetail?.id) === detailId) return matchDetail;

  return null;
};
